<template>
  <div class="select-container" :class="{ active }">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "common_styles/breakpoints" as breakpoints;
  @use "friendship_styles/colors" as colors;
  @use "friendship_styles/zindex" as zindex;

  .select-container{
    position: absolute;
    width: 365px;
    max-height: 288px;
    padding: 17px 30px 0 30px;
    border-radius: 6px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09), 0 0 8px 0 rgba(0, 0, 0, 0.09);
    overflow-y: auto;

    &.active {
      z-index: zindex.$dropdown-z-index;
    }

    @include breakpoints.screen-mobile-only {
      position: relative;
      margin-top: 10px;
      width: 340px;
    }

    ::v-deep(.v-autocomplete-input) {
      padding: 0 0 10px;
      display: block;
      width: 100%;
      font-weight: normal;
      background: transparent;
      border: none;

      &:focus {
        outline: none;
      }

      &::placeholder {
        color: colors.$unobtrusive-text-color;
      }
    }
  }
</style>
